export const PROMOCODE_STATUSES = {
  ALLOWED: 'PROMOCODE_ALLOWED',
  NOT_FOUND: 'PROMOCODE_NOT_FOUND',
  NOT_ALLOWED: 'PROMOCODE_NOT_ALLOWED',
  NOT_YET_ACTIVE: 'PROMOCODE_NOT_YET_ACTIVE',
  EXPIRED: 'PROMOCODE_EXPIRED',
  WRONG_SESSION: 'PROMOCODE_WRONG_SESSION',
  WRONG_EVENT: 'PROMOCODE_WRONG_EVENT',
  USAGE_LIMIT_EXCEEDED: 'PROMOCODE_USAGE_LIMIT_EXCEEDED',
  TICKET_LIMIT_EXCEEDED: 'PROMOCODE_TICKET_LIMIT_EXCEEDED',
} as const;
